import { Boton, InputDate, Label, Spinner, TextArea } from 'asocomponents';
import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { mostrarMensaje } from '../../../helpers/mensajeria'
import { MENSAJESAPP } from '../../../const/constantes'
import GrillaAdjuntoObservacion from '../GrillaAdjuntos/GrillaAdjuntoObservacion';
import { addDocumentos, addFiles, resetDocumentos } from '../../../redux/observacionSlice.js'
import { useDispatch, useSelector } from 'react-redux';
import { getFechaLocal, mostrarTipoDocumentoObservacion } from '../../../helpers/funciones.js'
import SelectTipoDocumentoObservacion from '../Selects/SelectTipoDocumentoObservacion/SelectTipoDocumentoObservacion.jsx';
import ObservacionService from '../../../../modules/Observacion/application/ObservacionService.js';

Modal.setAppElement('#root'); // Asegurate de tener un #root en index.html

export default function ModalAgregarObservacion({ isOpen, onClose, idObservacion, idJuicio, onSuccess }) {
    const documentosCargados = useSelector(state => state.rootReducer.datosObservacion.documentos)
    const dispatch = useDispatch()
    const usuarioString = sessionStorage.getItem("usuario") && JSON.parse(sessionStorage.getItem("usuario"))
    const fileCargados = useSelector(state => state.rootReducer.datosObservacion.files)

    const cuit = usuarioString.usuario

    const [observaciones, setObservaciones] = useState("")
    const [tipoDocumento, setTipoDocumento] = useState("")
    const [inputFile, setInputFile] = useState("")
    const [observacionesValido, setObservacionesValido] = useState(false)
    const [documentacionValida, setDocumentacionValida] = useState(false);
    const [fechaObservacionValido, setFechaObservacionValido] = useState(true)
    const [fechaObservacion, setFechaObservacion] = useState(getFechaLocal())
    const [resetKey, setResetKey] = useState(0);

    const [formEnviado, setFormEnviado] = useState(false);
    const [isLoadingEnviar, setIsLoadingEnviar] = useState(false)

    const formValido = observacionesValido && fechaObservacionValido //&& documentacionValida

    const validarTipoArchivo = (file) => {
        const tipoArchivo = file.type === 'application/pdf'
        const extensionArchivo = file.name.endsWith('.pdf')
        return !(tipoArchivo && extensionArchivo)
    }

    const agregarDocumentoAdjunto = (tipo, doc, name, size) => {

        const maxIndice = documentosCargados.length > 0
            ? Math.max(...documentosCargados.map(doc => doc.indice))
            : 0;

        const nuevoDocumento = {
            Sector: MENSAJESAPP.DOCDIGITALIZADOS.SECTOROBSERVACIONES,
            Autor: usuarioString ? cuit : MENSAJESAPP.DOCDIGITALIZADOS.AUTOROBSERVACIONJUICIO,
            Identifier: 0,
            indice: maxIndice + 1,
            tipo: tipo,
            tipoDescripcion: mostrarTipoDocumentoObservacion(tipo),
            nombre: name,
            fileSize: size
        };

        dispatch(addDocumentos(nuevoDocumento))
        dispatch(addFiles(doc))
    }

    const hanldeObservaciones = (valor) => {
        if (valor !== "") {
            setObservaciones(valor)
            setObservacionesValido(true)
        }
        else
            setObservacionesValido(false)
    }

    const limpiarForm = () => {
        setObservaciones("")
        //setFechaObservacion("")
        //setFechaObservacionValido(false)
        setObservacionesValido(false)
        dispatch(resetDocumentos())
    }

    const handleCancelar = () => {
        limpiarForm()
        onClose()
    }

    const handleTipoDocumento = (e) => {
        setTipoDocumento(e.target.value)
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        setInputFile(file)
    }

    const handleAgregarArchivo = () => {
        if (!tipoDocumento) {
            mostrarMensaje(MENSAJESAPP.DOCDIGITALIZADOS.SELEECCIONARTIPODOCUMENTO, "info", 2000)
            return false
        }
        if (!inputFile) {
            mostrarMensaje(MENSAJESAPP.DOCDIGITALIZADOS.SELEECCIONARDOCUMENTO, "info", 2000)
            return false
        }
        if (!tipoDocumento || validarTipoArchivo(inputFile)) {
            mostrarMensaje(MENSAJESAPP.DOCDIGITALIZADOS.SELEECCIONARTIPODOCUMENTOPDF, "info", 2000)
            return false
        }
        agregarDocumentoAdjunto(tipoDocumento, inputFile, inputFile.name, inputFile.size)
     }

    const handleAgregarObservacion = async (event) => {

        try {
            event.preventDefault();
            setIsLoadingEnviar(true)

            const observacionService = new ObservacionService()

            const observacion = {
                "nroJuicio": idJuicio,
                "observacion": observaciones,
                "fecha": fechaObservacion,
                "documentos": documentosCargados
            }

            const resultado = await observacionService.altaObservacionJuicio(observacion, fileCargados)

            if (resultado.message !== "ERROR") {
                mostrarMensaje(
                    MENSAJESAPP.CONFIRMACION.OBSERVACOINENVIADAOK,
                    "success",
                    3000
                )
            
                limpiarForm()
            
                if (onSuccess) {
                    onSuccess()
                }
            } else {
                mostrarMensaje(
                    MENSAJESAPP.ERRORES.FACTURANOENVIADA,
                    "error",
                    3000
                )
            }
        }
        catch (e) {
            mostrarMensaje(MENSAJESAPP.ERRORES.OBSERVCIONNOENVIADA, "error", 3000)
        }
        finally {
             setIsLoadingEnviar(false)
        }
    }

    const handleFechaObservacion = (fecha) => {
        if (fecha !== "") {
            if (Date.parse(fecha) > Date.now()) {
                setFechaObservacion("")
                setResetKey(prev => prev + 1)
                setFechaObservacionValido(false)
                mostrarMensaje(MENSAJESAPP.VALIDACIONES.FECHAFACTURA, "error", 2000)
            } else {
                setFechaObservacionValido(true)
                setFechaObservacion(fecha)
            }
        }
    }

    useEffect(() => {
        if (documentosCargados.length === 1)
            setDocumentacionValida(true)
        else
            setDocumentacionValida(false)
    }, [documentosCargados])

    useEffect(() => {
        limpiarForm()
    }, [formEnviado])

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Agregar Pago"
            className="bg-white p-6 rounded-lg w-[950px] max-w-full mx-auto mt-10 outline-none"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start z-50"
        >
            <div className={`max-h-[80vh] overflow-y-auto  ${!idObservacion ? '' : 'pointer-events-none'}`} >
                <h2 className="text-xl font-bold mb-4 text-center">NUEVA OBSERVACIÓN DEL PROCESO JUDICIAL</h2>
            </div>
            <div className="overflow-x-auto">
                <div className="flex flex-row ml-10 m-3 w-[87%] mx-auto">
                    <div className='flex flex-row w-[85px]'><Label texto="Fecha:" /></div>
                    <div className='flex flex-row'><InputDate width='w-40' onChange={handleFechaObservacion} valor={fechaObservacion} key={resetKey} disabled="true" />{!fechaObservacionValido && <Label texto="(*)" color="text-asociart-custom" />}</div>
                </div>
            </div>
            <div className="overflow-x-auto">
                <div className="flex flex-row ml-10 m-3 w-[87%] mx-auto">
                    <Label texto="Observación:" />
                    <TextArea width="w-full" height="h-28" onChange={hanldeObservaciones} valor={observaciones} maxlength="255" />
                </div>
            </div>
            <div className="overflow-x-auto">
                <div className="flex flex-row ml-10 m-3 w-[87%] mx-auto">
                    <Label texto="Documentos Adjuntos:" />
                </div>
            </div>
            <div className={`grid grid-cols-3 gap-4 mb-5 items-center ${documentacionValida && "hidden"}`}>
                <div className="flex justify-center">
                    <SelectTipoDocumentoObservacion
                        width="w-44"
                        onChange={handleTipoDocumento}
                    />
                </div>
                <div className="flex justify-center">
                    <input
                        type="file"
                        accept=".pdf"
                        onChange={handleFileChange}
                        className="p-1 pr-2 text-gray-900 sm:text-xs focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div className="flex justify-start">
                    <Boton
                        texto="Adjuntar Archivos"
                        fondo="rojo"
                        onClick={handleAgregarArchivo}
                        height="h-8"
                        width="w-40"
                    />
                </div>
            </div>
            <div className="flex justify-end items-center gap-3 mt-6">
                <GrillaAdjuntoObservacion idObservacion={idObservacion} />
            </div>
            <div className="flex justify-end items-center gap-3 mt-6">
                <button className="bg-gray-400 text-white px-4 py-2 rounded" onClick={handleCancelar}>Cancelar</button>
                {isLoadingEnviar ? (
                    <Spinner color="red" size="20" />
                ) : (
                    <button className={`${formValido ? "bg-rose-600" : "bg-gray-200"} text-white px-4 py-2 rounded`}
                        disabled={!formValido} onClick={handleAgregarObservacion}>Agregar</button>)
                }
            </div>
        </Modal>
    );
}
